import { ApolloError } from '@apollo/client';

export function retrieveNetworkErrorFromApollo(e: ApolloError): string {
  if (e.networkError && 'result' in e.networkError) {
    // eslint-disable-next-line
    return e.networkError.result.errors[0].message;
  }
  return 'Unexpected error';
}
